import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';

import {MatTableDataSource} from '@angular/material';
import { ItemGrid } from '../../../models/item';
import { modalComponent } from '../../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { ActivatedRoute,Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import {SelectionModel} from '@angular/cdk/collections';

import { Usuario } from '../../../models/usuario';
import { modalConfirmationComponent } from '../../../utils/modal/modal-confirmation.component';

import * as jsPDF from 'jspdf';
import * as pdfMake from 'pdfmake/build/pdfmake';
import {TDocumentDefinitions} from 'pdfmake/build/pdfmake';
import { text } from '@fortawesome/fontawesome-svg-core';
// import { dataPolizaPDF } from 'src/app/models/poliza';
import { dataPolizaPDF } from '../../../models/poliza';
import { utils } from '../../../utils/utils';;
export interface PolizaElement {
  cargos: number;
  abonos: number;
  estatus: string;
  tipo:string;
  
  select:boolean;
  COMPANY_ID: number;
  CREATED_BY:number;
  CREATION_DATE: Date;
  DESCRIPTION:string;
  NUMBER:string;
  ORGANIZATION_ID:number;
  POLIZA_ID:number;
  POLIZA_STATUS_ID:number;
  POLIZA_TYPE_ID:number;
  num_conciliaciones:number;
}
export interface PolizaStatusElement {
  POLIZA_STATUS_ID: number;
  NAME:string;
}
export interface PolizaTypeElement {
  POLIZA_TYPE_ID: number;
  NAME:string;
}
/*
var ELEMENT_DATA: PolizaElement[] = [
{
  id: 4,
  num_poliza: 'Num 4',
  tipo: 'Tipo 4',
  fecha: new Date(),
  descripcion: 'Descripcion 4',
  cargos: 4.0,
  abonos: 4.1,
  select:false,
  estatus: 'Estatus 4'
}
];
*/

@Component({
  selector: 'app-polizas-consultar',
  templateUrl: './polizas-consultar.component.html',
  styleUrls: ['./polizas-consultar.component.scss'],
  providers: [generalService,utils]
})
export class PolizasConsultarComponent implements OnInit {
  ELEMENT_DATA: PolizaElement[] =[]
  polizaStatus_DATA:PolizaStatusElement[]=[]
  polizaType_DATA:PolizaTypeElement[]=[]
  selPoliza:PolizaElement=null
  public _utils:utils;
  constructor(private formBuilder: FormBuilder,
    private _generalService: generalService,
  private router:Router,public dialog: MatDialog, private __utils: utils) {
        this.myForm = new FormGroup({});
        this._utils = new utils();
    }

ngOnInit() {
this.buildForm();

this.consultarHistoricoPoliza();
this.consultarPolizaStatus();
this.consultarPolizaType();
}

// Y afectarFunc
desafectarFunc(row:PolizaElement,tipo:string){
  let num_conciliaciones = row.num_conciliaciones;
  if(num_conciliaciones > 0){
    this._generalService.toastCall('"No es posible desafectar la Póliza, favor de cancelar la conciliación bancaria correspondiente"');
  }else{
    console.warn(row)
  console.warn(row.NUMBER)
  console.warn(row.NUMBER.slice(3,7))//3,7
  let yearSel=parseInt(row.NUMBER.slice(3,5));
  let monthSel=parseInt(row.NUMBER.slice(5,7)).toString();
  // console.warn("yearSel",yearSel)//3,7
  // console.warn("monthSel",monthSel)//3,7
  // console.warn(tipo)
  const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  const organizationId = usuario.ORGANIZATION_ID;
  
        this._generalService.metodoCallParams(
          {
            ORGANIZATION_ID:organizationId,
            COMPANY_ID:usuario.COMPANY_ID,
            POLIZA_ID:row.POLIZA_ID,
            TIPO:tipo,
            YEAR:yearSel,
            CARGO:"CARGO"+monthSel,
            ABONO:"ABONO"+monthSel,
          },this.polizaService + `afectarDesafectarPoliza`, true)
          .subscribe((polizaCreada) => {
            // console.warn(polizaCreada)
            this._generalService.toastCall('Poliza actualizada correctamente.');
            this.consultarHistoricoPoliza()
          }, (error) => {
          });
  }
  
  num_conciliaciones = 0;    
}

private polizaService = 'poliza/';

consultarHistoricoPoliza() {
const rangoInicio = this.dateRange.startDate.format('YYYY-MM-DD');
const rangoFinal = this.dateRange.endDate.format('YYYY-MM-DD');

const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
const organizationId = usuario.ORGANIZATION_ID;
let estatusSend=this.myForm.get('estatusForm').value;
let numberSend=this.myForm.get('numPolizasForm').value;
let tipoPoliza=this.myForm.get('tipoPolizaForm').value;
// console.warn(rangoInicio);
// console.warn(rangoFinal);
// console.warn(estatusSend==''?null:estatusSend)
// console.warn(numberSend ==''?null:numberSend)

//consultarPoliza
//this._generalService.metodoCallParams({},this.polizaService + `/consultarHistoricoCorte?organizationId=${organizationId}&&rangoInicio=${rangoInicio}&&rangoFinal=${rangoFinal}`, true)
this._generalService.metodoCallParams(
{
POLIZA_STATUS_ID:estatusSend==''?null:estatusSend,
NUMBER:numberSend ==''?null:numberSend,
FECHA_INICIO:rangoInicio,
FECHA_FIN:rangoFinal,
ORGANIZATION_ID:organizationId,
POLIZA_TYPE_ID:tipoPoliza,
},this.polizaService + `consultarPoliza`, true)
.subscribe((historicos) => {
// console.warn(historicos)
this.ELEMENT_DATA=historicos
this.dataSource.data=historicos
//this.actualizarGrid.next(historicos);
}, (error) => {
});
}

consultarPolizaStatus() {
const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
const organizationId = usuario.ORGANIZATION_ID;
//consultarPoliza
this._generalService.metodoCallParams({},this.polizaService + `consultarPolizaStatus`, true)
.subscribe((polizaStatus) => {
// console.warn(polizaStatus)
this.polizaStatus_DATA=polizaStatus
}, (error) => {
});
}
consultarPolizaType() {
  const usuario: Usuario = JSON.parse(sessionStorage.getItem('user'));
  const organizationId = usuario.ORGANIZATION_ID;
  //consultarPoliza
  this._generalService.metodoCallParams({},this.polizaService + `consultarPolizaType`, true)
  .subscribe((res) => {
  // console.warn(polizaStatus)
    this.polizaType_DATA=res
    }, (error) => {
    });
  }
buildForm(){
this.myForm = this.formBuilder.group({
fechasForm: [''],
numPolizasForm:  [''] ,
estatusForm: [''],
tipoPolizaForm:[''],
});
}

  checkCambiar(row:PolizaElement,event:any){
    // console.warn("prev",event.checked)
    // console.warn("prev",row)
    // console.warn(this.dataSource.data)
    if(event.checked){

      if(this.selPoliza==null){
        this.selPoliza=row
        for(var i=0;i<this.dataSource.data.length;i++){
          if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
            this.dataSource.data[i].select=true;
            break;
          }
        }
      }else{
        for(var i=0;i<this.dataSource.data.length;i++){
          if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
            this.dataSource.data[i].select=false;
            this.selPoliza=row
                  
              for(var i=0;i<this.dataSource.data.length;i++){
                if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
                  this.dataSource.data[i].select=true;
                  this.selPoliza=row
                  break;
                }
              }
            break;
          }
        }
        
      }
    }else{
      
      for(var i=0;i<this.dataSource.data.length;i++){
        if(this.dataSource.data[i].POLIZA_ID==this.selPoliza.POLIZA_ID){
          this.dataSource.data[i].select=false;
          this.selPoliza=null
          break;
        }
      }
    }
    
    // console.warn("post",row)
    // console.warn(this.dataSource.data)
  }
  myForm: FormGroup;
  
  dataSource = new MatTableDataSource<PolizaElement>(this.ELEMENT_DATA);
  companyName = "";
  public dataReporteCuenta: any[] = [];

  dateRange: any = {
      startDate: moment().startOf('month'),
      //startDate: moment().subtract(7, 'days'),
      endDate: moment()
  };
  ranges: any = {
      'Hoy': [moment(), moment()],
      'Semana actual': [moment().startOf('week'), moment().endOf('week')],
      'Mes actual': [moment().startOf('month'), moment().endOf('month')]
  };

  displayedColumns = [
      'acciones', 
      //'select',
      'num_poliza', 'tipo',  'fecha', 'descripcion','cargos', 'abonos', 'estatus'
  ];
  
  editPoliza(row:PolizaElement){
    //POLIZA_ID
    //  console.warn(row);
     this.router.navigate([ '/app/polizas/polizas-editar/'+row.POLIZA_ID])
    .then(nav => {
      console.log(nav); // true if navigation is successful
    }, err => {
      console.log(err) // when there's an error
    });
  }

  //cancelar
  confirmDelete(row:PolizaElement){
    //POLIZA_ID
    console.warn(row)
    const dialogRef = this.dialog.open(modalConfirmationComponent, {
      disableClose: true, data: {
        mensaje: '¿Desea cancelar la poliza: ' + row.NUMBER + '?',  }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
      if(result == 1){
        //cambiar POLIZA_STATUS_ID=2
        console.warn("Eliminar: "+row.POLIZA_ID)
        
        this._generalService.metodoCallParams({POLIZA_ID:row.POLIZA_ID},this.polizaService + `cancelarPoliza`, true)
        .subscribe((polizaStatus) => {
          console.warn(polizaStatus)
          this.consultarHistoricoPoliza()
        }, (error) => {
        });

       }
    });
  }
  reactivateRow(row:PolizaElement){
    console.warn(row)
  }
  mostrarModalAgregar(row:PolizaElement){
    console.warn(row)
  }

  selection = new SelectionModel<PolizaElement>(true, []);

/** Whether the number of selected elements matches the total number of rows. */
isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.data.length;
  return numSelected === numRows;
}

/** Selects all rows if they are not all selected; otherwise clear selection. */
masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
}

polizasAdd(){
  
  this.router.navigate([ '/app/polizas/polizas-agregar'])
    .then(nav => {
      console.log(nav); // true if navigation is successful
    }, err => {
      console.log(err) // when there's an error
    });
  //this.router.url.subscribe(([url]) => {
  //  const { path, parameters } = url;
  //  console.log(path); // e.g. /products
  //  console.log(parameters); // e.g. { id: 'x8klP0' }
  //});
  //polizas/polizas-agregar
}
exportarPDF(row:any){
    // var dataExcel:dataPolizaPDF={
    //   fiscalName: '',
    //   numberPoliza: '',
    //   tipoPolizaName: '',
    //   creationDate: undefined,
    //   descripcion: '',
    //   detallePoliza: [],
    // };
    // dataExcel.tipoPolizaName = "Tipo Poliza";
    // dataExcel.creationDate = new Date();
    // dataExcel.descripcion="Descripción poliza";
    // dataExcel.fiscalName = "Numero Fiscal";
    // dataExcel.numberPoliza = "12345";
    // dataExcel.detallePoliza.push({abono:12,cargo:22,concepto:"Concepto 1",cuenta:"dfdf",descripcion:"ddf",partida:123,referencia:"dfdf"});

    this._generalService.metodoCallParams({POLIZA_ID:row.POLIZA_ID},this.polizaService + `getDataParaExportarPoliza`, true)
        .subscribe((dataExcel:dataPolizaPDF) => {
          this.descargarExcel(dataExcel);
          
        }, (error) => {
        });

   

}
descargarExcel(data:dataPolizaPDF)
{
  

  const doc = new jsPDF("p", "pt", "letter");
  
  var totalCargo =data.detallePoliza.reduce((total, currentValue) => total + currentValue.cargo,0);
  var totalAbono =data.detallePoliza.reduce((total, currentValue) => total + currentValue.abono,0);

  var bodyTable=[
    [
        { text: 'Partida', bold: true, alignment: 'center' },
        { text: 'Cuenta', bold: true, alignment: 'center' },
        { text: 'Descripción', bold: true, alignment: 'center'},
        { text: 'Concepto', bold: true, alignment: 'center'},
        { text: 'Referencia', bold: true, alignment: 'center'},
        { text: 'Cargo', bold: true, alignment: 'center'},
        { text: 'Abono', bold: true, alignment: 'center' }
    ]
    ];
    data.detallePoliza.forEach(element => {
        bodyTable.push([
            {text: element.partida.toString(),bold: false, alignment: 'right'},
            {text: element.cuenta,bold: false, alignment: 'left'},
            {text: element.descripcion,bold: false, alignment: 'left'},
            {text: element.concepto,bold: false, alignment: 'left'},
            {text: element.referencia,bold: false, alignment: 'left'},
            {text:new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(element.cargo),bold: false, alignment: 'right'},
            {text:new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(element.abono),bold: false, alignment: 'right'}
        ])
    });
var footerTable = [
  [
    {text: "", alignment: 'left',bold: false},
      {text: "", alignment: 'left',bold: false},
      {text: "", alignment: 'left',bold: false},
      {text: "", alignment: 'left',bold: false},
      {text: "Totales", alignment: 'left',bold: true},
      {text: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(totalCargo), alignment: 'right',bold: true},
      {text: new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(totalAbono), alignment: 'right',bold: true},
  ]
];
  const documentDefinition:TDocumentDefinitions = { 
    content: [                      
      {text:data.fiscalName,alignment:"center"},
      {text:"Póliza",alignment:"center"},
      {
          layout: "noBorders",
          table: {
          
            widths: [ '20%', '20%', "20%",'20%', '20%' ],
          
            body: [
              [ {text:"Núm. Póliza:",bold:true}, {text:data.numberPoliza,alignment:"left"},{text:""} ,{text:"Fecha Poliza:",bold:true}, {text:this._utils.changeFormatDate(data.creationDate,"dd-mm-yyyy" ),alignment:"left"} ],
              [ { text: 'Tipo de Póliza:', bold: true ,marginTop:5}, {text:data.tipoPolizaName,alignment:"left",marginTop:5}, {text:""},{text:"",bold:true,marginTop:5}, {text:"",alignment:"left",marginTop:5} ],
            ]
          }
      },
      {text:"\n"}
      ,
      {
        layout: "noBorders",
        table: {
        
          widths: [ '15%', '85%' ],
        
          body: [
            [ {text:"Descripción:",bold:true}, {text:data.descripcion,alignment:"left"}],
            
          ]
        }
      }, 
      {
        style: 'tablePrincipal',
        table: {
            headerRows: 1,
            widths: ['8%',"17.5%","17.5%","13%","13%",'15%','15%'],
            body:bodyTable
        },
        
      },
      {
        layout: "noBorders",
        table: {
            widths: ['8%',"17.5%","17.5%","13%","13%",'15%','15%'],
            body:footerTable
        },
      }
  ],

  styles: {            
    tablePrincipal: {
      margin: [0, 20, 0, 0]
    },
    header: {
      bold: true,
      fontSize: 11,
      color: 'black',
      margin: [0, -5, 0, 0]
    },
  },
  defaultStyle: {
    // columnGap: 20
  },
  pageMargins: [20, 20, 20, 20],
 };
  
  let x = pdfMake.createPdf(documentDefinition).download(data.numberPoliza);
}
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/polizas/polizas-consultar/polizas-consultar.component.ts